import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbUpActionFilled.svg';

export const IconThumbUpActionFilled = createIconComponent(Icon);
